import React from 'react'
import logo from "./footer-ndt-logo.png";
import { Link } from 'react-router-dom';
import sponsor from './ndt-sponsor-footer.jpg'
import sponsormobile from './image/ndt_mob_banner.jpg'
export default function Footer() {
  return (
  <>

  <section className='sponsor1'>

    <div className='logosponsor mobilenone'>
      <div className=''></div>
      <img src={sponsor} className='img-fluid'/>
    </div>

    <div className='logosponsor compnone'>
      <div className=''></div>
      <img src={sponsormobile} className='img-fluid'/>
    </div>
  </section>
  
      <section className="footer mnone">
        <div className='logofoter'>
          <img src={logo} className='img-fluid footerlogo'/>
        </div>
<div className="footermenu">
 <ul className="d-flex">
  <li><a href="/about-us">About Us</a></li>
  <li><a href="/standing">Standings</a></li>
  <li><a href="/squad">Squad</a></li>
  <li><a href="/auction">Auction</a></li>


 </ul>
</div>

      </section>
      
<div className="footercpoy">
  <p>&copy; 2025 New Delhi Tigers. All rights reserved.</p>
</div>



<div class="s-soft">
<Link to="https://www.facebook.com/newdelhitigers" target='_blank' class="s-item facebook">
<span class="fa fa-facebook"></span>
</Link>

<a href="https://www.instagram.com/newdelhitigers/" target='_blank' class="s-item pinterest">
<span  class="fa fa-instagram"></span>
</a>

{/* <a href="https://www.youtube.com/@BrijStars" target='_blank' class="s-item pinterest">
<span  class="fa fa-youtube-play"></span>
</a> */}


</div></>


  )
}
